import { createSlice } from '@reduxjs/toolkit';

// types

import { ConfirmationProps } from 'ui-component/extended/CustomConfirmDialog';

const initialState: ConfirmationProps = {
    title: '',
    children: undefined,
    open: false,
    setOpen: (open: boolean) => {},
    onConfirm: (dontShowAgain?: boolean) => {},
    onClose: () => {},
    onCancel: ()=> {},
    showDontShowAgain: false,
    hideCancelButton: false,
    confirmText: 'yes'
    // action: false,
    // open: false,
    // message: 'Note archived',
    // anchorOrigin: {
    //     vertical: 'top',
    //     horizontal: 'center'
    // },
    // variant: 'alert',
    // alert: {
    //     color: 'primary',
    //     variant: 'filled'
    // },
    // transition: 'SlideRight',
    // close: true,
    // actionButton: true,
    // autoHideDuration: 1500
};

// ==============================|| SLICE - SNACKBAR ||============================== //

const confirmation = createSlice({
    name: 'confirmation',
    initialState,
    reducers: {
        
        openGeneralAlertConfirmation (state, action)  {
            // console.log(action.payload);
            const { open,title, children, handleConfirmed } =
                action.payload;

            // state.action = !state.action;
            state.open = open || initialState.open;
            state.title = title;
            if (children) {
                state.children = children;
            } else {
                state.children = initialState.children;
            }
            state.onConfirm = handleConfirmed;
           // state.onClose = handleConfirmationClosed;
            state.hideCancelButton = true;
            state.confirmText = 'Close';
            state.showDontShowAgain = false;
    },
        openConfirmation(state, action) {
            const { open,title, children, handleConfirmed, handleConfirmationClosed,onclose,showDontShowAgain } =
                action.payload;

            // state.action = !state.action;
            state.open = open || initialState.open;
            state.title = title;
            if (children) {
                state.children = children;
            // } 
            // else if (alert?.color == 'success') {
            //     state.message = 'Changes successfully saved';
            // } else if (alert?.color == 'error') {
            //     state.message = 'Failed saving changes';
            } else {
                state.children = initialState.children;
            }

            // state.anchorOrigin = anchorOrigin || initialState.anchorOrigin;
            // state.variant = variant || initialState.variant;
            // state.alert = {
            //     color: alert?.color || initialState.alert.color,
            //     variant: alert?.variant || initialState.alert.variant
            // };
            // state.transition = transition || initialState.transition;
            // state.close = close === false ? close : initialState.close;
            // state.actionButton = actionButton || initialState.actionButton;
            // state.autoHideDuration = autoHideDuration || initialState.autoHideDuration;
            state.onConfirm = handleConfirmed;
            state.onCancel = handleConfirmationClosed;
            state.onClose = onclose;
            state.showDontShowAgain = showDontShowAgain;
        },

        closeConfirmation(state) {
            state.open = false;
        }
    }
});

export default confirmation.reducer;

export const { closeConfirmation, openConfirmation ,openGeneralAlertConfirmation} = confirmation.actions;
